<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 768 768" style="enable-background:new 0 0 768 768;" xml:space="preserve">
        <g>
            <path class="st0" d="M767.52,297.64l-265.03-38.36L383.85,19.18L265.47,259.4L0.48,298.05l191.86,186.82l-45.12,263.95
		    l236.91-124.69l237.12,124.44l-45.39-263.93L767.52,297.64z M386.08,437.8c2.08-4.71,6.94-7.55,12.07-7.04l-8.24-41.95
		    c-18.74,2.41-34.86,14.44-42.51,31.72c-8.54,19.22-5.3,41.63,8.32,57.64l10.44,10.3l-2.8,98.74l-159.88,84.16l32.01-187.35
		    c32.49-70.28,103.44-116.19,185.07-121l-0.64,20.3l22.57,120.93l-55.02-54.2C384.8,446.51,384.27,441.82,386.08,437.8z
		     M405.73,587.54l1.66-58.42l33.17,32.7l49.71-32.5l-27.88-149.23l1.93-59.15l-21.29-0.6c-97.85-2.78-186.42,44.39-233.47,122.16
		    l-118-114.89l202.06-29.49l90.34-183.18l90.47,183.08l202.08,29.27L530.35,469.91l34.63,201.25L405.73,587.54z" />
        </g>
    </svg>
</template>
<style type="text/css">
.st0 {
    fill: #FCEA0D;
}

</style>
